const initialState = {};

export default function config(state = initialState, action) {
	switch (action.type) {
		default:
			return state;
	}
}
